import { IAbExperimentsState } from './types';
import {
  HOMEOWNERS_FORM_COMMUNICATION,
  COMMERCIAL_OWNER_EXPERIMENT,
  HOMEOWNERS_NEW_ADD_FORM,
} from '../../../constants/experiments';

export const AB_EXPERIMENT_DEFAULTS: IAbExperimentsState = {
  [HOMEOWNERS_FORM_COMMUNICATION]: null,
  [COMMERCIAL_OWNER_EXPERIMENT]: null,
  [HOMEOWNERS_NEW_ADD_FORM]: null,
};
